import React, { useEffect, useState } from 'react'
import { useMediaQuery } from '@material-ui/core'
import AssignId from '../AssignId'
import Container from '../Container'
import styles from './ColoriFormati.module.sass'
import { Plus, Minus, Close } from '../icons'
import VisibilitySensor from '../VisibilitySensor';
import { ColoriFormatiPageConfig } from '../configuration';


function ColoriFormati() {
  const isMobile = useMediaQuery('(max-width: 760px)')

  const [hoveredElement, setHoveredElement] = useState(null)
  const [lastHoveredElement, setLastHoveredElement] = useState(null)
  const [openElement, setOpenElement] = useState(null)
  const [openElementMobile, setOpenElementMobile] = useState(null)
  const [animationGo, setAnimationGo] = useState(false)
  const [animationBack, setAnimationBack] = useState(false)

  useEffect(() => {
    // Gestisce l'animazione quando cambia l'open element nella versione desktop
    if (hoveredElement){
      setLastHoveredElement(hoveredElement)
      setAnimationGo(true)
      setTimeout(() => {
        setAnimationGo(false)
      }, 300)
    }
    else {
      setAnimationBack(true)
      setTimeout(() => {
        setAnimationBack(false)
        setLastHoveredElement(null)
      }, 300)
    }
  }, [hoveredElement])


  return (
    <>
      <div className={styles.root}>
        <Container>
          <div className={styles.main}>
            <AssignId
              absolute
              y='-120px'
              yMobile='-80px'
              id={ColoriFormatiPageConfig.id}
            />
            <VisibilitySensor index={5} />
            <div className={`${styles.content} scroll-fadein`}>
              <h1 className={styles.title}>{ColoriFormatiPageConfig.title}</h1>
              <div className={styles.description}>
                <p dangerouslySetInnerHTML={{ __html: ColoriFormatiPageConfig.description }} />
              </div>
            </div>
            <div className={`${styles.list} scroll-fadein-late`}>
              {ColoriFormatiPageConfig.elements.map(x => (
                <div 
                  key={x.key}
                  className={`${styles.item} ${animationGo ? styles['item--animationGo'] : ''} ${animationBack ? styles['item--animationBack'] : ''} ${openElement?.key === x.key ? styles['item--open'] : ""} ${hoveredElement ? hoveredElement.key === x.key ? styles['item--hovered'] : styles['item--noHovered'] : '' } ${lastHoveredElement ? lastHoveredElement.key === x.key ? styles['item--lastHovered'] : styles['item--noLastHovered'] : '' }`} 
                  onClick={() => {
                    setOpenElement(openElement?.key === x.key ? null : x);
                    setOpenElementMobile(openElement?.key === x.key ? null : x);
                    if (window.dataLayer) {
                      window.dataLayer.push({
                        'event': 'lp_cta_body',
                        'cta_clicked': x.title,
                        'section': 'Osmos'
                      });
                    }
                  }}
                >
                  <div className={styles.itemImageBox} onMouseEnter={() => { setHoveredElement(x); setOpenElement(null) }} onMouseLeave={() => { setHoveredElement(null); setOpenElement(null) }}>
                    <img src={(isMobile) ? x.imageMobile : x.image} className={styles.itemImage} alt={x.title} />
                    <div className={styles.formati}>
                      <p className={styles.formatiTitle}>{ColoriFormatiPageConfig.formatsTitle}</p>
                      <div className={styles.formatiList}>
                        {x.formati.map(f => (
                          <div className={styles.formatiItem} key={f.key}>
                            <div className={styles.formatiItemImageBox}>
                              <img src={f.image} alt={`${x.title} - ${f.title}`} />
                            </div>
                            <p className={styles.formatiItemTitle}>{f.title}</p>
                            <div className={styles.formatiItemDescription} dangerouslySetInnerHTML={{ __html: f.description }} />
                          </div>
                        ))}
                      </div>
                      <div className={styles.formatiMinus}><Minus /></div>
                    </div>
                    <div className={styles.itemButton}>
                      <span className={styles.itemButtonLabel}>{ColoriFormatiPageConfig.discoverFormatsLabel}</span>
                      <Plus />
                    </div>
                  </div>
                  <div className={styles.itemContent}>
                    <p className={styles.itemTitle}>{x.title}</p>
                    <div className={styles.itemDescription}dangerouslySetInnerHTML={{ __html: x.description }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>
      <div className={`${styles.formatiModalOverlay} ${openElementMobile ? styles['formatiModalOverlay--visible'] : ''}`} onClick={() => setOpenElementMobile(null)} />
      <div className={`${styles.formatiModal} ${openElementMobile ? styles['formatiModal--visible'] : ''}`}>
        <button className={styles.formatiModalClose} onClick={() => setOpenElementMobile(null)}>
          <Close />
        </button>
        {!!openElementMobile && (
          <>
            <p className={styles.formatiModalTitle}>{openElementMobile.title}</p>
            <p className={styles.formatiModalDescription}>{openElementMobile.description}</p>
            <div className={styles.formatiModalList}>
              {openElementMobile.formati.map(f => (
                <div className={styles.formatiItem} key={f.key}>
                  <div className={styles.formatiItemImageBox}>
                    <img src={f.image} alt={`${openElementMobile.title} - ${f.title}`} />
                  </div>
                  <p className={styles.formatiItemTitle}>{f.title}</p>
                  <p className={styles.formatiItemDescription}>{f.description}</p>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default ColoriFormati